import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
      ]
    },
    clientname: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
      ]
    },
    StartTime: {
      validations: []
    },
    EndTime: {
      validations: []
    },
    SiteName: {
      validations: []
    },
    Theme: {
      validations: []
    },
    PlannedGuestCount: {
      validations: []
    },
    Reference: {
      validations: []
    },   
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'FirstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name:',
            mapping: 'clientname'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event Start Time:',
                options: [
                  { label: '6:00 AM', value: '06:00:00' },
                  { label: '6:30 AM', value: '06:30:00' },
                  { label: '7:00 AM', value: '07:00:00' },
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' },
                  { label: '10:30 PM', value: '22:30:00' },
                  { label: '11:00 PM', value: '23:00:00' },
                  { label: '11:30 PM', value: '23:30:00' },
                  { label: '12:00 AM', value: '00:00:00' },
                  { label: '12:30 AM', value: '00:30:00' },
                  { label: '1:00 AM', value: '01:00:00' },
                  { label: '1:30 AM', value: '01:30:00' },
                  { label: '2:00 AM', value: '02:00:00' },
                  { label: '2:30 AM', value: '02:30:00' },
                  { label: '3:00 AM', value: '03:00:00' },
                  { label: '3:30 AM', value: '03:30:00' },
                  { label: '4:00 AM', value: '04:00:00' },
                  { label: '4:30 AM', value: '04:30:00' },
                  { label: '5:00 AM', value: '05:00:00' },
                  { label: '5:30 AM', value: '05:30:00' }
                ],
                mapping: 'StartTime'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event End Time:',
                options: [
                  { label: '6:00 AM', value: '06:00:00' },
                  { label: '6:30 AM', value: '06:30:00' },
                  { label: '7:00 AM', value: '07:00:00' },
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' }
                ],
                mapping: 'EndTime'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Venue Name:',
                mapping: 'SiteName'
              }
            ]
          },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Theme of Event:',
            options: [
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Gala', value: 'Gala'},
              { label: 'Cocktail Reception', value: 'Cocktail Reception'},
              { label: 'Birthday', value: 'Birthday'},
              { label: 'Other', value: 'Other'},
            ],
            mapping: 'Theme'
          }
        ]
      },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Estimated Number of People:',
                mapping: 'PlannedGuestCount'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'How Did You Hear About Us?:',
                options: [
                  { label: 'EventUp', value: 'EventUp'},
                  { label: 'Instagram', value: 'Instagram'},
                  { label: 'Facebook', value: 'Facebook'},
                  { label: 'Search Engine', value: 'Search Engine'},
                  { label: 'Email', value: 'Email'},
                  { label: 'Other', value: 'Other'},
                ],
                mapping: 'Reference'
              }
            ]
          },
          {
            fields: [
              {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Pavilion Contact Form',
    formId: '2192',
    clientKey: '079C9ED5-058A-44A8-B6DD-7CA6BD4A8220',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
